module.exports = __webpack_public_path__ + "static/media/screen05.ca980df9.png";